import { Injectable } from "@angular/core";
import { RestServiceBase } from "@definitiv-packages/angular-dba-library";
import { SysLandModel } from "../../../public-api";

@Injectable({
    providedIn: 'root'
})
export class SysLandService extends RestServiceBase<SysLandModel> {
    constructor(
    ) {
        super("SysLandModel", false);
    }
}